'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = require('redux');

var _makerReducer = require('../reducers/makerReducer');

var _makerReducer2 = _interopRequireDefault(_makerReducer);

var _draftJs = require('draft-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEW_REPORT = {
	title: 'New Report',
	description: '',
	isPrivate: true,
	status: 'published',
	components: [
		// { 
		// 	type: 'chart', 
		// 	title: 'Chart Title',
		// 	chartType: 'bar',
		// 	description: '',
		// 	dataPoints: [],
		// 	groupBy: [],
		// 	filters: []
		// },
		// { 
		// 	type: 'text', 
		// 	editorState: convertToRaw(EditorState.createEmpty().getCurrentContent())
		// },
	]
};

// temp


if (typeof INITIAL_DATA !== 'undefined') {
	INITIAL_DATA.components = INITIAL_DATA.components.map(function (c, i) {
		c.id = i;
		return c;
	});
}

var initialState = typeof INITIAL_DATA !== 'undefined' ? INITIAL_DATA : NEW_REPORT;

exports.default = (0, _redux.createStore)(_makerReducer2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default));


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/stores/makerStore.js
// module id = 529
// module chunks = 0